import { apiClient } from "./api-client"
import { FileDto } from "@/types/file"

export const fileApi = {
  upload: (file: File, onProgress?: (progress: number) => void) => {
    const formData = new FormData()
    formData.append("file", file)

    return apiClient.upload<FileDto>('/files/upload', formData, undefined, onProgress)
  },

  getFile: (id: string) => {
    return apiClient.get<Blob>(`/files/${id}`, { responseType: "blob" })
  },

  getFileUrl: (id: string) => {
    return apiClient.get<string>(`/files/${id}/url`)
  },
}
